<template>
  <a href="https://wa.me/+79265874227" target="_blanc">
    <svg class="ks-socials__icon--svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.415 14.382C17.117 14.233 15.656 13.515 15.384 13.415C15.112 13.316 14.914 13.267 14.715 13.565C14.517 13.861 13.948 14.531 13.775 14.729C13.601 14.928 13.428 14.952 13.131 14.804C12.834 14.654 11.876 14.341 10.741 13.329C9.858 12.541 9.261 11.568 9.088 11.27C8.915 10.973 9.069 10.812 9.218 10.664C9.352 10.531 9.515 10.317 9.664 10.144C9.813 9.96998 9.862 9.84598 9.961 9.64698C10.061 9.44898 10.011 9.27598 9.936 9.12698C9.862 8.97798 9.268 7.51498 9.02 6.91998C8.779 6.34098 8.534 6.41998 8.352 6.40998C8.178 6.40198 7.98 6.39998 7.782 6.39998C7.584 6.39998 7.262 6.47398 6.99 6.77198C6.717 7.06898 5.95 7.78798 5.95 9.25098C5.95 10.713 7.014 12.126 7.163 12.325C7.312 12.523 9.258 15.525 12.239 16.812C12.949 17.118 13.502 17.301 13.933 17.437C14.645 17.664 15.293 17.632 15.805 17.555C16.375 17.47 17.563 16.836 17.811 16.142C18.058 15.448 18.058 14.853 17.984 14.729C17.91 14.605 17.712 14.531 17.414 14.382H17.415ZM11.993 21.785H11.989C10.2184 21.7853 8.48037 21.3093 6.957 20.407L6.597 20.193L2.855 21.175L3.854 17.527L3.619 17.153C2.62914 15.5773 2.10529 13.7538 2.108 11.893C2.11 6.44298 6.544 2.00898 11.997 2.00898C14.637 2.00898 17.119 3.03898 18.985 4.90698C19.9054 5.82356 20.6349 6.91355 21.1313 8.11388C21.6277 9.31421 21.8811 10.6011 21.877 11.9C21.875 17.35 17.441 21.785 11.993 21.785ZM20.405 3.48798C19.3032 2.3789 17.9922 1.49952 16.5481 0.90078C15.1039 0.302044 13.5553 -0.00413728 11.992 -2.00576e-05C5.438 -2.00576e-05 0.102 5.33498 0.1 11.892C0.099 13.988 0.646 16.034 1.687 17.837L0 24L6.304 22.346C8.04787 23.2961 10.0021 23.7939 11.988 23.794H11.993C18.547 23.794 23.883 18.459 23.885 11.901C23.8898 10.3383 23.5848 8.79008 22.9874 7.34601C22.3901 5.90195 21.5124 4.59065 20.405 3.48798Z"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </a>
</template>

<script>
export default {}
</script>

<style>
.ks-socials__icon--svg {
  cursor: pointer;
  width: 3rem;
  height: 3rem;
  fill: black;
}
.ks-socials__icon--svg {
  transition: 0.4s ease;
}
.ks-socials__icon--svg:hover {
  fill: var(--color-primary);
  transform: translateY(-4px);
}
</style>
